import React, { useState, useEffect } from 'react';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { PageSection, useGlobal } from '@rcg/ui-react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { useQuery } from '@apollo/client';
import useStyles from './index.style';
import MakePayment from '../MakePayment';
import PaymentHistory from '../PaymentHistory/index';
import { GET_PAYMENT_HISTORY } from '../../graphql/queries';
import Loader from '../Loader/index';
import { displayWarningNotification, displayErrorNotification } from '../../commons/3dsValidation';
import { handlePaymentError } from '../../commons/paymentNotifications';
import NotificationBannerComponent from '../NotificationBanner';
import { getSessionStorageItem } from '../../commons/utils';
import { BOOKING_TYPES, SESSION_STORAGE_CURRENT_BOOKING } from '../../commons/constants';

const PaymentOverlay = (props) => {
  const [displayLoader, setDisplayLoader] = useState(true);
  const classes = useStyles();
  const {
    arrivalDateTime,
    departureDateTime,
    departurePort,
    description,
    dictionaries,
    pageSection,
    paymentErrorInfo,
    paymentResponse,
    price,
    renderContent,
    setMakePaymentInfo,
    setPaymentErrorInfo,
    setPaymentresponseInfo,
    ship,
    showNotification,
    currentBooking,
    royalPayway,
    isMobile,
    setNotificationDashboard,
    closeModal,
    refetch,
    payment3dsToggle,
  } = props;

  const {
    data: { lang, isoCode },
  } = useGlobal();
  const isGrpBooking =
    getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING)?.type === BOOKING_TYPES.GRP;
  const isTABooking =
    getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING)?.type === BOOKING_TYPES.TA;
  const {
    called: paymentHistoryCalled,
    error: dataError,
    loading: loadPayment,
    data: paymentData,
  } = useQuery(GET_PAYMENT_HISTORY, { fetchPolicy: 'no-cache', skip: isGrpBooking || isTABooking });

  useEffect(() => {
    setDisplayLoader(loadPayment);
  }, [loadPayment]);

  let paymentHistoryData;
  if (paymentHistoryCalled && !loadPayment && !dataError) {
    paymentHistoryData = paymentData?.currentBooking?.paymentHistory;
  }

  const [propNotification, setNotification] = useState({
    description: '',
    open: false,
    title: '',
    type: '',
  });

  useEffect(() => {
    if (paymentErrorInfo) {
      window.scrollTo(0, 0);
      handlePaymentError(paymentErrorInfo, renderContent, setNotification);
    }

    if (paymentResponse) {
      refetch();
      setNotificationDashboard();
      setPaymentresponseInfo(null);
      closeModal();
    }
    if (dataError) {
      setNotification({
        description: renderContent(
          'paymentBookingAmendPaymentHistoryMessageError',
          'We are unable to retrieve the payment information. Please try again later',
        ),
        open: true,
        title: renderContent('paymentBookingAmendPaymentHistoryErrorTitle', 'Technical Issues'),
        type: 'error',
      });
    }
    if (dataError) {
      setNotification({
        description: renderContent(
          'paymentBookingAmendPaymentHistoryMessageError',
          'We are unable to retrieve the payment information. Please try again later',
        ),
        open: true,
        title: renderContent('paymentBookingAmendPaymentHistoryErrorTitle', 'Technical Issues'),
        type: 'error',
      });
    }
  }, [
    paymentErrorInfo,
    paymentResponse,
    renderContent,
    setPaymentErrorInfo,
    setPaymentresponseInfo,
    showNotification,
    dataError,
  ]);

  const showWarningNotification = () => {
    document.querySelector('.contentDialog').scrollTo(0, 0);
    displayWarningNotification(setNotification, renderContent);
  };

  const showErrorNotification = () => {
    document.querySelector('.contentDialog').scrollTo(0, 0);
    displayErrorNotification(setNotification, renderContent);
  };

  return (
    <div>
      {propNotification.open && (
        <div className={classes.notificationContainer}>
          <NotificationBannerComponent
            {...propNotification}
            renderCloseBtn
            isBannerOpen
            onClose={() => setNotification({ open: false })}
          />
        </div>
      )}
      <Container data-testid="modal-container" className={classes.paymentOverlay}>
        <Box className="paymentOverlayWrapper">
          <Box className={classes.notification} />
          <Typography className={classes.h1}>{description}</Typography>
          <Box className={classes.itInfo}>
            <Typography component="h2">
              {dictionaries.leaving} {dictionaries.from}:
            </Typography>
            <Box component="span">{departurePort.name}</Box>
            {departurePort.region && <Box component="span">, {departurePort.region}</Box>}
          </Box>
          <Box className={classes.itInfo}>
            <Typography component="h2">{dictionaries.onboard}:</Typography>
            <Box component="span">{ship.name}</Box>
          </Box>
          <Box className={classes.itInlineDate}>
            <Box component="span" className="from">
              {departureDateTime}
            </Box>
            <ArrowForward />
            <Box component="span" className="to">
              {arrivalDateTime}
            </Box>
          </Box>
        </Box>
        {currentBooking.price.balanceDue > 0 && [
          <PageSection title={pageSection.title} description={pageSection.description} />,
          <MakePayment
            isMobile={isMobile}
            price={price}
            lang={lang || 'en'}
            isoCode={isoCode || 'US'}
            setMakePaymentInfo={setMakePaymentInfo}
            dictionaries={dictionaries}
            rooms={[]}
            paymentResponse={paymentResponse}
            paymentErrorInfo={paymentErrorInfo}
            currentBooking={currentBooking}
            showWarningNotification={showWarningNotification}
            showErrorNotification={showErrorNotification}
            royalPayway={royalPayway}
            payment3dsToggle={payment3dsToggle}
          />,
        ]}
        <PaymentHistory price={price} paymentHistoryData={paymentHistoryData} />
      </Container>
      <Loader display={displayLoader} />
    </div>
  );
};

export default PaymentOverlay;
